<template>
  <tr>
    <td>
      <span class="brand">{{ product.brand }}</span>
      <h4>{{ product.name }}</h4>
      <code>{{ product.upc_13 }}</code>
    </td>
    <td>
      {{ asCurrency(product.srp_amount) }} /
      {{ product.unit_of_measure | unit-of-measure 1 true }}
    </td>
    <td class="text-center toggle">
      <button
        type="button"
        @click="toggleStockStatus()"
        :class="{
          'btn-success': !product.in_stock,
          'btn-default': product.in_stock,
        }"
        class="btn btn-lg btn-toggle"
      >
        <i class="fa fa-check"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import { has } from 'lodash';
import { Api, IO, updateProduct, asCurrency } from 'src/utilities';
import TogglesStockStatus from 'mixins/TogglesStockStatus';

let socketListeners = [];

export default {
  mixins: [TogglesStockStatus],

  props: [
    {
      name: 'product',
      type: Object,
      default: {},
    },
  ],

  attached() {
    const listeners = IO.on('product.updated', payload => {
      if (payload.id !== this.product.id) {
        return;
      }

      if (has(payload, 'in_stock')) {
        this.toggleStockStatus(false);
      }
    });

    // attach socket.io listener for product stock
    socketListeners = socketListeners.concat(listeners);
  },

  methods: {
    asCurrency,
  },
};
</script>



// WEBPACK FOOTER //
// ProductWithStock.vue?69670c5b